import type React from 'react';

/** @deprecated Use icons from icons-v2-generated instead. */
export interface NetworkIconProps extends React.SVGProps<SVGSVGElement> {
  color?: string;
}

/** @deprecated Use icons from icons-v2-generated instead. */
export function NetworkIcon({ className = 'h-6 w-6', color = 'white', ...props }: NetworkIconProps) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill={color}
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      {...props}
    >
      <path d="M14.5005 14.1245V11.2505H5.74951V14.1245C5.74951 14.7458 5.24583 15.2495 4.62451 15.2495C4.00342 15.2492 3.49951 14.7457 3.49951 14.1245V11.2505H1.125C0.503842 11.2505 0.00026374 10.7466 0 10.1255C0 9.50417 0.50368 9.00049 1.125 9.00049H9V6.125C9 5.50368 9.50368 5 10.125 5C10.7463 5 11.25 5.50368 11.25 6.125V9.00049H19.125L19.2407 9.00635C19.8077 9.0643 20.25 9.54325 20.25 10.1255C20.2498 10.7075 19.8075 11.1867 19.2407 11.2446L19.125 11.2505H16.7505V14.1245C16.7505 14.7457 16.2466 15.2492 15.6255 15.2495C15.0042 15.2495 14.5005 14.7458 14.5005 14.1245Z" />
      <path d="M13.2495 18H18V15.2505H13.2495V18ZM2.25 18H7.00049V15.2505H2.25V18ZM7.24951 4.99951H13.0005V2.25H7.24951V4.99951ZM9.25049 18.1245C9.25049 19.2981 8.2986 20.25 7.125 20.25H2.12549C0.951883 20.25 0 19.2981 0 18.1245V15.1245C0.000264358 13.9511 0.952046 13.0005 2.12549 13.0005H7.125C8.29844 13.0005 9.25022 13.9511 9.25049 15.1245V18.1245ZM20.25 18.1245C20.25 19.2981 19.2981 20.25 18.1245 20.25H13.125C11.9514 20.25 10.9995 19.2981 10.9995 18.1245V15.1245C10.9998 13.9511 11.9516 13.0005 13.125 13.0005H18.1245C19.298 13.0005 20.2497 13.9511 20.25 15.1245V18.1245ZM15.2505 5.12549C15.2502 6.29887 14.2984 7.24951 13.125 7.24951H7.125C5.95156 7.24951 4.99978 6.29887 4.99951 5.12549V2.12549C4.99951 0.951883 5.9514 0 7.125 0H13.125C14.2986 0 15.2505 0.951883 15.2505 2.12549V5.12549Z" />
    </svg>
  );
}
